export default {
    data() {
        return {
            $ajaxName: []// Ajax令牌数组
        };
    },
    beforeDestroy() {
        this.$ajaxCancelAll();// 取消全部Ajax
    },
    methods: {
        /**
         * 发送Ajax
         * @param baseURL 基础请求路径
         * @param url 请求路径
         * @param method 请求方法
         * @param name ajax名称
         * @param autoCancel 组件销毁自动取消ajax
         * @param qs 是否使用qs库
         * @param errHandler 是否自动处理错误
         * @param bigData 是否使用无埋点统计
         * @param headers 请求头
         * @param data 请求数据
         * @param mockServer 请求模拟数据服务器
         * @param ms 请求模拟数据服务器缩写
         * @param mockData 模拟数据对象
         * @param timeout 模拟数据延迟返回的毫秒数
         * @param javaServer 请求发往java服务器
         * @param beforeSend 发送前执行的回调
         * @param errCallback 自动处理错误后执行的回调
         * @param success 成功的回调
         * @param complete 完成的回调
         * @param error 错误的回调
         * @param cancelError 主动取消错误的回调
         */
        $ajax(
            {
                baseURL = '',
                url = '',
                method = 'post',
                name = null,
                autoCancel = true,
                qs = true,
                errHandler = true,
                bigData = true,
                headers = {},
                data = {},
                ms = false,
                mockServer = false,
                mockData = null,
                timeout = 300,
                javaServer = false,
                beforeSend = () => {
                },
                errCallback = () => {
                },
                success = () => {
                },
                complete = () => {
                },
                error = () => {
                },
                cancelError = () => {
                },
            }
        ) {
            if (ms || mockServer || window.sessionStorage.getItem('localAjax') === 'local') {
                url = 'http://localhost:9898';
                setTimeout(() => {
                    this.$Message({
                        msg: '模拟数据已发送！'
                    });
                }, 0);
            }

            // 如果有模拟数据返回模拟数据
            if (mockData !== null) {
                beforeSend();
                setTimeout(() => {
                    resSuccess({data: mockData}, this);
                    complete();
                }, Number(timeout));
                return;
            }

            // 声明token
            let ajaxToken = this.$axios.CancelToken.source();

            // 如果传入名字
            if (name) {
                const nameArr = name.split('.');// 获取到每一层对象
                let nowName = this;// 当前的ajaxName
                let prevName = this;// 上一层的ajaxName
                nameArr.forEach((item, index) => {
                    nowName = nowName[item];// 获取到当前字符串
                    if (nameArr.length - 1 !== index) {
                        prevName = prevName[item];// 获取前一层对象
                    }
                });

                // 取消之前的请求
                this.$ajaxCancel(nowName);
                // 赋值令牌
                prevName[nameArr[nameArr.length - 1]] = ajaxToken;
            }

            // 如果需要自动取消ajax
            if (autoCancel) {
                this.$data.$ajaxName.push(ajaxToken);
            }

            // 发送前执行
            beforeSend();

            // axios对象初始化
            let axiosObj = {
                baseURL: baseURL,
                url: url,
                method: method,
                headers: headers,
            };

            // ajax令牌
            axiosObj.cancelToken = ajaxToken.token;

            // 有发送的数据
            if (method === 'post') {
                // url 拼接 act
                data.act && !javaServer && (axiosObj.url += `?act=${data.act}`);

                // 当调java接口使用json传参
                if (javaServer) {
                    axiosObj.headers['apiType'] = 'java';
                    axiosObj.headers['Content-Type'] = 'application/json; charset=UTF-8';
                    axiosObj.data = data;
                }
                // 判断是否使用qs库
                else if (qs) {
                    axiosObj.data = this.$qs.stringify(data);
                } else {
                    axiosObj.data = data;
                }
            } else if (axiosObj.method === 'get') {
                axiosObj.params = data;
                axiosObj.params._ = +new Date();
            } else {
                // 预留的method方法 比如HEAD
            }

            this.$axios(axiosObj).then((res) => {
                resSuccess(res, this);
            }).catch((err) => {
                // 主动取消
                if (this.$axios.isCancel(err)) {
                    cancelError();
                    if (err.message !== '') {
                        console.log(err.message);
                    }
                } else {
                    error();
                }
            }).then(() => {
                complete();
                // 无埋点大数据统计
                if (bigData) {
                    // this.$buriedFreeStatistics(url, data);
                }
            });

            /**
             * 处理Ajax返回的数据
             * @param res
             * @param _this
             */
            function resSuccess(res, _this) {
                if (res.data.generalErrMsg && errHandler) {
                    _this.$generalErrFn(res.data.generalErrMsg);
                } else if (res.data.errMsg && errHandler) {
                    let errMsg = res.data.errMsg;
                    _this.$Alert({
                        msg: errMsg,
                        callback: () => {
                            errCallback();
                        }
                    });
                } else {
                    success(res.data, res);
                }
            }
        },
        /**
         * 取消ajax
         * @param name ajaxName
         * @param cancelStr 取消ajax原因
         */
        $ajaxCancel(name, cancelStr = '') {
            if (name) {
                name.cancel(cancelStr);
            }
        },
        /**
         * 通用错误处理
         * @param err
         */
        $generalErrFn(err) {
            switch (err) {
                case 'noSession':
                    setTimeout(() => {
                        if (this.$route.fullPath.includes('/personalCenter/operationCenter/cargoQuery/importBusiness')) {
                            if (this.$isIntl() || !this.$isZh()) {
                                this.$Alert({
                                    msg: this.$t('message.currentPageHasExpired'),
                                    callback: () => {
                                        window.top.location.href = '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportLogin';
                                    }
                                });
                            } else {
                                this.$Alert({
                                    msg: this.$t('message.currentPageHasExpired'),
                                    callback: () => {
                                        window.top.location.href = '/';
                                    }
                                });
                            }                        
                        } else {
                            this.$Alert({
                                msg: this.$t('message.currentPageHasExpired'),
                                callback: () => {
                                    window.top.location.href = '/';
                                }
                            });
                        }
                    }, 200);           
                    break;
                case 'noAuthority':
                    this.$Alert({
                        msg: this.$t('message.noPermission'),
                        callback: () => {
                            window.top.location.href = '/personalCenter/PersonalCenterMain';
                        }
                    });
                    break;
                case 'noAuthorityOrder':
                    this.$Alert({
                        msg: this.$t('message.noAuthorityOrder'),
                    });
                    break;
                default:
                    this.$Alert({
                        msg: err,
                    });
                    break;
            }
        },
        /**
         * 取消全部Ajax
         */
        $ajaxCancelAll() {
            // 遍历取消Ajax
            this.$data.$ajaxName.map((item) => {
                this.$ajaxCancel(item);
            });
        }
    }
};
